import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";

import OrganisationFilter from "@components/DashBoard/OrganisationFilter/OrganisationFilter";
import { FILTER_OPTIONS } from "@constants/dashboard";
import { OrganisationFinderProps } from "@models/components/organisation.model";
import dashboardSlice from "@slices/dashboard.slice";
import { RootState } from "@store/index";
import { isMobile } from "@utils/common.utils";

const OrganizationFinder: React.FC<OrganisationFinderProps> = ({
  filterChange,
  filterValue,
  organisationData,
}) => {
  const [showFilter, setShowFilter] = useState<boolean>(false);

  const { accessToken } = useSelector((state: RootState) => state.local);
  const { isSearch } = useSelector((state: RootState) => state.dashboard);

  const dispatch = useDispatch();

  useEffect(() => {
    customStyleAdd();
  }, [showFilter, isMobile()]);

  const closeModal = () => {
    setShowFilter(false);
  };

  const customStyleAdd = () => {
    const element: HTMLElement | null =
      document.querySelector(".fg-org-finder");
    const mainElement: HTMLElement | null =
      document.querySelector(".fg-main-wrapper");
    const body: HTMLElement | null = document.querySelector("body");

    if (showFilter && isMobile()) {
      if (element) element.style.position = "static";
      if (mainElement) mainElement.style.position = "static";
      if (body) body.style.overflow = "hidden";
    } else if (!showFilter && isMobile()) {
      if (element) element.style.position = "relative";
      if (mainElement) mainElement.style.position = "relative";
      if (body) body.style.overflow = "";
    }
  };

  const handleButtonClick = (
    filter: FILTER_OPTIONS.ALL | FILTER_OPTIONS.MY_REGISTERED
  ) => {
    if (filterChange) {
      filterChange(filter);
    }
  };

  const resetSearch = () => {
    dispatch(
      dashboardSlice.actions.setLocation({
        city: "",
        club: "",
        country: "",
        isCity: true,
        isSearch: false,
      })
    );
  };

  return (
    <div className="fg-org-finder">
      <h4>{t("organizationFinder")}</h4>
      {showFilter && (
        <OrganisationFilter
          closeModal={closeModal}
          filterChange={filterChange}
          organisationData={organisationData}
        />
      )}
      <div className="fg-org-finder-right">
        {accessToken && (
          <button
            onClick={() => {
              handleButtonClick(FILTER_OPTIONS.MY_REGISTERED);
              resetSearch();
            }}
            className={
              "btn fg-btn fg-btn-small fg-btn-my-reg " +
              (filterValue === FILTER_OPTIONS.MY_REGISTERED ? "active" : "")
            }
            data-testid="my-registered-button"
          >
            <i className="fa-regular fa-circle-user"></i>
            {t("myRegistered")}
          </button>
        )}
        <button
          onClick={() => {
            handleButtonClick(FILTER_OPTIONS.ALL);
            resetSearch();
          }}
          className={
            "btn fg-btn fg-btn-small fg-btn-my-reg " +
            (filterValue === FILTER_OPTIONS.ALL ? "active" : "")
          }
          data-testid="all-button"
        >
          {t("all")}
        </button>
        <button
          className={`btn fg-btn fg-btn-small fg-btn-my-reg fg-filter-trigger ${
            isSearch && filterValue === FILTER_OPTIONS.FILTER ? "active" : ""
          }`}
          onClick={() => {
            setShowFilter(true);
          }}
        >
          <i className="fa-solid fa-filter"></i>
          {t("filterBy")}
        </button>
      </div>
    </div>
  );
};

export default OrganizationFinder;
